module.exports = __webpack_public_path__ + "img/page-16.216ad126.jpg";